export default __webpack_public_path__ + "static/media/assessment_bg.82fff785.svg";